// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminRotateJwsResponse

export type AdminRotateJwsApiResponse = {
	jwks_url: string;
};

export type AdminRotateJws = {
	jwks_url: string;
};

export function hydrateAdminRotateJws(data: AdminRotateJwsApiResponse): AdminRotateJws {
	return { ...data };
}